import React from 'react';

/**
 * Componente para anuncios de Google AdSense
 *
 * INSTRUCCIONES PARA CONFIGURAR:
 * 1. Ve a https://www.google.com/adsense
 * 2. Crea tu cuenta y espera aprobación
 * 3. Una vez aprobado, obtén tu código de publicador (ca-pub-XXXXXXXXXXXXXXXX)
 * 4. Reemplaza 'YOUR_ADSENSE_CLIENT_ID' con tu ID real
 * 5. Los anuncios comenzarán a mostrarse automáticamente
 */

const ADSENSE_ENABLED = process.env.REACT_APP_ENABLE_ADSENSE === 'true';

const AdSense = ({
  slot,
  format = 'auto',
  responsive = true,
  style = {},
  className = ''
}) => {
  const adInitialized = React.useRef(false);

  React.useEffect(() => {
    if (!ADSENSE_ENABLED || process.env.NODE_ENV !== 'production' || !/^\d+$/.test(slot || '')) return;

    const initializeAd = () => {
      if (adInitialized.current) return;
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        adInitialized.current = true;
      } catch (err) {
        console.error('AdSense error:', err);
      }
    };

    if (window.adsbygoogle) {
      initializeAd();
      return;
    }

    const script = document.querySelector('script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]');
    script?.addEventListener('load', initializeAd, { once: true });
    return () => script?.removeEventListener('load', initializeAd);
  }, [slot]);

  if (!ADSENSE_ENABLED) return null;

  // En desarrollo o sin AdSense configurado, mostrar placeholder
  if (process.env.NODE_ENV !== 'production') {
    return (
      <div
        className={`bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center ${className}`}
        style={{ minHeight: '200px', ...style }}
      >
        <div className="text-center p-4">
          <p className="text-gray-500 font-semibold">Espacio para Anuncio de AdSense</p>
          <p className="text-gray-400 text-sm mt-2">
            Aparecerá cuando configures tu cuenta de AdSense
          </p>
        </div>
      </div>
    );
  }

  if (!/^\d+$/.test(slot || '')) return null;

  return (
    <ins
      className={`adsbygoogle ${className}`}
      style={{ display: 'block', ...style }}
      data-ad-client={process.env.REACT_APP_ADSENSE_CLIENT || 'ca-pub-6255131651488482'}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive.toString()}
    />
  );
};

export default AdSense;
